const KEY = 'ctc_recent_suppliers';
const MAX = 12;

export const recordRecentSupplier = (s) => {
  if (!s || !s.slug) return;
  try {
    const list = getRecentSuppliers().filter((x) => x.slug !== s.slug);
    list.unshift({ slug: s.slug, name: s.name, logo: s.logo || null });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch { /* ignore quota / disabled storage */ }
};

export const getRecentSuppliers = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((x) => x && x.slug) : [];
  } catch { return []; }
};
